export enum WizardMode {
  view,
  edit,
}

export enum FieldConfiguratorTab {
  page,
  settings,
}
